import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [onboardingCheck, setOnboardingCheck] = useState<"loading" | "complete" | "incomplete">("loading");

  useEffect(() => {
    if (!user) {
      setOnboardingCheck("loading");
      return;
    }

    // Skip check if already on onboarding page
    if (location.pathname === "/onboarding") {
      setOnboardingCheck("complete");
      return;
    }

    supabase
      .from("profiles")
      .select("onboarding_completed")
      .eq("user_id", user.id)
      .maybeSingle()
      .then(({ data }) => {
        setOnboardingCheck(data?.onboarding_completed ? "complete" : "incomplete");
      });
  }, [user, location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  // Redirect to onboarding if profile not complete
  if (onboardingCheck === "incomplete") {
    return <Navigate to="/onboarding" replace />;
  }

  // Show loader while checking onboarding status
  if (onboardingCheck === "loading" && location.pathname !== "/onboarding") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
